import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { DialogFooter } from '../DialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
export const PanelFooter = _ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(DialogFooter, Object.assign({}, rest));
};
PanelFooter.displayName = 'PanelFooter';